module.exports = __webpack_public_path__ + "img/unvergessen-logo-grey.c706c3a2.png";